export default __webpack_public_path__ + "static/media/iceberg.4577e4b9.png";